import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHourglassRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.4 3.2a1.2 1.2 0 1 0 0 2.4h.4v1q0 3.1 2.2 5.3l4.1 4.1-4 4a8 8 0 0 0-2.3 5.5v.9h-.4a1.2 1.2 0 1 0 0 2.4h11q-.8-1-1.3-2.4H7.2v-1q0-2 1.5-3.6l4.1-4.1 1.6 1.6 1.3-2-1.2-1.3 4-4a8 8 0 0 0 2.3-5.4v-1h.4a1.2 1.2 0 1 0 0-2.4zm8.4 11.1-4-4Q7.1 8.6 7.1 6.5v-1h11.2v1q0 2.1-1.5 3.6zm17.6 8.9a7.2 7.2 0 1 0-14.4 0 7.2 7.2 0 0 0 14.4 0m-7.2-4q.7.1.8.8v2.4h1.6q.7.1.8.8-.1.7-.8.8h-2.4a1 1 0 0 1-.8-.8V20q.1-.7.8-.8" })
});
export default SvgHourglassRegularIcon;
